import { createClient } from '@sanity/client'

export default createClient({
    projectId: "atfjnhb5",
    dataset: "production"
})